import { IReportService } from "../../service/report/ReportService";

export default class GetRiskCriteriaInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(reportingPeriodId: number) {
    return this.reportService.getRiskCriteria(reportingPeriodId);
  }
}
